export var REACT_TYPEOF_KEY = '$$typeof';
export var CONNECTED_NAMESPACE = 'data-g2-c16t';
export var CONTEXT_COMPONENT_NAMESPACE = 'data-g2-c5tc8t';
/**
 * Special key where the connected namespaces are stored.
 * This is attached to Context connected components as a static property.
 */

export var CONNECT_STATIC_NAMESPACE = '__contextSystemKey__';